import api from '@/lib/api';

/** Cattura un lead dal popup (email + consenso marketing). Best-effort. */
export async function captureLeadPopup(data: { email: string; marketingConsent: boolean }): Promise<void> {
  await api.post('/leads/popup', data);
}
